import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../features/login/loginSlice';

// Middleware for logging in development
const loggerMiddleware = store => next => action => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Dispatching:', action);
  }
  const result = next(action);
  if (process.env.NODE_ENV === 'development') {
    console.log('New state:', store.getState());
  }
  return result;
};

// Error handling middleware
const errorMiddleware = store => next => action => {
  try {
    return next(action);
  } catch (error) {
    console.error('Redux error:', error);
    // Could dispatch error action here
    throw error;
  }
};

export const store = configureStore({
  reducer: {
    login: loginReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(loggerMiddleware, errorMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
